module.exports = __webpack_public_path__ + "static/media/main_visual_agriculture_telehandler_mlt_x_625_75_h_manitou.d087825b.png";